"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxyLogger = exports.ProxyLogger = void 0;
const Logging_1 = require("../../Logging");
const debug = false;
const { AWS_LAMBDA_FUNCTION_NAME } = process.env;
const functionName = AWS_LAMBDA_FUNCTION_NAME || 'mock';
/** used in unit test to replace logger, so developers can get output to console without changing code
 * When constructed here the defaul level is ERROR
 */
class ProxyLogger {
    /** constructor for the proxy logger
     * @param logAtLevel - the level at which to log messages
     * @param useTimestampPrefix - whether to use a timestamp prefix in the log message (for cloudwatch output from ECS)
     */
    constructor(logAtLevel = Logging_1.LogLevel.ERROR, useTimestampPrefix = true) {
        this.messages = [];
        this.flush = async () => {
            const res = { err: null, data: { httpStatusCode: 0, bucket: 'no-bucket', key: 'no-key' } };
            console.log('Proxy Logger Flush');
            return res;
        };
        this.proxyLogAtLevelFn = (logLevel) => (...args) => {
            const now = new Date();
            const res = {
                functionName, level: logLevel, message: args, timestamp: now.valueOf(),
            };
            const logEntryPrefix = this.useTimestampPrefix ? `${now.toISOString()} ` : '';
            const logAtLevelIdx = Logging_1.LogLevel[logLevel];
            debug && console.log(`ProxyLogger with setting ${Logging_1.LogLevel[this.logAtLevel]} (${this.logAtLevel}) got message with level ${Logging_1.LogLevel[logAtLevelIdx]} (${logAtLevelIdx})`);
            if (logAtLevelIdx >= this.logAtLevel || logLevel === 'SYSTEM') {
                console.log(`${logEntryPrefix}ProxyLogger ${logLevel}:`, ...args);
            }
            else {
                debug && console.log(`ProxyLogger ${logLevel} not logged because ${logAtLevelIdx} < ${Logging_1.LogLevel[this.logAtLevel]}`);
            }
            return res;
        };
        this.debug = this.proxyLogAtLevelFn('DEBUG');
        this.trace = this.proxyLogAtLevelFn('TRACE');
        this.info = this.proxyLogAtLevelFn('INFO');
        this.warn = this.proxyLogAtLevelFn('WARN');
        this.error = this.proxyLogAtLevelFn('ERROR');
        this.fatal = this.proxyLogAtLevelFn('FATAL');
        this.system = this.proxyLogAtLevelFn('SYSTEM');
        // provisionally a function that allows specific messages to be logged outside of LOG_AT_LEVEL
        this.special = (...args) => this._logSpecial && console.log(`ProxyLogger SPECIAL:`, ...args);
        debug && console.log(`Setting proxy logger level to`, logAtLevel);
        this._logAtLevel = logAtLevel;
        this.useTimestampPrefix = useTimestampPrefix ?? false;
        this._logSpecial = true;
    }
    set logAtLevel(logLevel) {
        debug && console.log(`ProxyLogger got set logAtLevel ${logLevel}`);
        this._logAtLevel = logLevel;
    }
    get logAtLevel() {
        return this._logAtLevel;
    }
    /** allows special logging, default true, provided not imported as ILambdaLogger, may be used to toggle investigative logging */
    set logSpecial(onOff) {
        this._logSpecial = onOff;
    }
}
exports.ProxyLogger = ProxyLogger;
exports.proxyLogger = new ProxyLogger(Logging_1.LogLevel.INFO);
